export type TRCApiResponse<T> = Promise<{
  from: string;
  msg?: string;
  data?: T;
  err: number;
}>;
export enum UserType {
  TEACHER_RECRUITMENT = 'TeacherRecruitment',
  ONECLUB_ID = 'OneClubId',
  REFERENCE_SYSTEM = 'ReferenceSystem',
}
export interface IPayload {
  userType: UserType;
}
export interface IPayloadCreateReferenceSystem {
  userType: UserType;
  userId: string;
  referralCode?: string;
  referredBy?: string;
  email: string;
}
export interface IDataExistReferenceSystem {
  id: string;
  userType: UserType;
  userId: string;
  referralCode?: string;
  referredBy?: string;
  createdAt: string;
  updatedAt: string;
  appliedReferralCodeTime?: string;
  email?: string;
  emailVerified?: boolean;
}
export interface IPayloadUpdate {
  referredBy?: string;
  appliedReferralCodeTime?: string;
  referralCode?: string;
}

export interface IPayloadCallback {
  referralCode: string;
  referredBy: string;
  checkSubmit?: boolean;
  appliedReferralCodeTime?: string;
}
